import { useContext, useState } from "react";
import { AppContext } from "../App";
import logo from '../assets/logo_icon.png';
import logo_worded from '../assets/logo_worded.png';
import { callApi, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdPerson, MdVisibility, MdVisibilityOff } from "react-icons/md";

export default function Login(props) {
  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // New state for visibility

  async function login() {
    if (!loading) {
      if (phone.trim().length > 0) {
        if (password.trim().length > 0) {
          setLoading(true);
          await callApi("login", { phone, password }).then((response) => {
            if (response.status === 1) {
              setCookie('adminId', response.userId);
              setCookie('adminToken', response.userToken);
              appContext.tellMessage("Welcome....");
              appContext.navTo({ item: 'dashboard' });
              appContext.refresh();
            } else {
              appContext.tellError(response.msg);
            }
          });
          setLoading(false);
        } else {
          appContext.tellError("Invalid Password");
        }
      } else {
        appContext.tellError("Invalid Email or Phone");
      }
    } else {
      appContext.tellInfo("Signing in, Please wait....");
    }
  }

  return (
    <div className="login-wrapper">
      <div className="login-card animate-fade-in">
        <div className="login-header">
          <img src={logo} alt="Logo Icon" className="login-logo-icon" />
          <img src={logo_worded} alt="Logo Name" className="login-logo-worded" />
        </div>

        <div className="login-form">
          <div className="modern-input-group">
            <label>Phone</label>
            <div className="input-wrapper">
              <MdPerson className="input-icon" />
              <input
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
                placeholder="Enter your phone"
                type="text"
              />
            </div>
          </div>

          <div className="modern-input-group">
            <label>Password</label>
            <div className="input-wrapper">
              <MdLock className="input-icon" />
              <input
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                placeholder="••••••••"
                type={showPassword ? "text" : "password"}
              />
              <button 
                type="button" 
                className="visibility-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
              </button>
            </div>
          </div>

          <button
            className={`modern-login-btn ${loading ? 'loading' : ''}`}
            onClick={login}
            disabled={loading}
          >
            {loading ? getInlineLoader({ variant: 'button', centered: false, label: 'Signing in' }) : (
              <>
                <span>Sign In</span>
                <MdLogin size={20} />
              </>
            )}
          </button>
        </div>
        
      </div>
    </div>
  );
}
